import { create } from "zustand";
import { isPushEnabled } from "../lib/notifications";

/** Whether this browser has push on (its notification permission is granted). */
interface PushState {
  enabled: boolean;
  setEnabled(enabled: boolean): void;
}

export const usePushStore = create<PushState>()((set) => ({
  enabled: isPushEnabled(),
  setEnabled: (enabled) => set({ enabled }),
}));
